<template>
  <div>
    <div class="display-flex justify-space-between align-center mb-3">
      <div class="display-flex gap-8 align-center">
        <div class="library__title">Library</div>
      </div>
      <div class="library__select font-weight-500">Create</div>
    </div>

    <div class="text-poppins-16 my-2 pt-2">New Releases</div>
    <div class="horizontal-scroll">
      <div v-for="i in 5" :key="i" class="horizontal-scroll__item mr-2 mb-2">
        <div>
          <img
            src="../../assets/mobile/library_1.png"
            width="151"
            height="151"
          />
        </div>
        <div class="font-15 font-weight-500 text-white">Amazing</div>
        <div class="text-grey-4 font-15 font-weight-500">Nighttime</div>
      </div>
    </div>

    <div class="text-poppins-16 my-2">Playlists</div>
    <div class="horizontal-scroll">
      <div v-for="i in 5" :key="i" class="horizontal-scroll__item mr-2 mb-2">
        <div>
          <img
            src="../../assets/mobile/library_2.jpg"
            width="151"
            height="151"
          />
        </div>
        <div class="font-15 font-weight-500 text-white">Rap Jams</div>
      </div>
    </div>

    <div class="text-poppins-16 font-weight-700 my-2">YOUR ALBUMS</div>
    <div class="horizontal-scroll">
      <div v-for="i in 5" :key="i" class="horizontal-scroll__item mr-2 mb-2">
        <div>
          <img
            src="../../assets/mobile/library_3.jpg"
            width="151"
            height="151"
          />
        </div>
        <div class="font-15 font-weight-500 text-white">Title</div>
        <div class="text-grey-4 font-15 font-weight-500">Artist name</div>
      </div>
    </div>

    <div class="my-4 display-flex justify-space-between align-center">
      <div class="text-poppins-16 text-white">Tracks (1,239)</div>
    </div>

    <div v-for="i in 5" :key="i" class="my-4 display-flex align-center gap-8">
      <div>
        <img src="../../assets/mobile/library_4.jpg" width="48" height="48" />
      </div>
      <div>
        <div class="text-poppins-16 text-white">Never gonna give you up</div>
        <div class="display-flex align-center gap-4">
          <img
            src="../../assets/mobile/icon/download-circle.svg"
            width="16"
            height="16"
          />
          <span class="text-poppins-14 font-weight-500 text-grey-5">
            Rick Astley
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.library {
  &__title {
    color: #fff;
    font-size: 24px;
    font-weight: 500;
    line-height: 70%;
    letter-spacing: -0.48px;
  }

  &__category {
    color: rgba(255, 255, 255, 0.7);
    font-size: 15px;
    font-weight: 500;
    border-radius: 60px;
    background: rgba(255, 255, 255, 0.1);
    height: 35px;
  }
  &__select {
    color: rgba(255, 255, 255, 0.9);
    font-size: 12px;
    height: 28px;
    padding: 5px 16px;
    background-color: #3c3c3c;
    border-radius: 34px;
    width: 77px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// library.vue?51fdf0b7